import Comment from '../models/Comment';
import { BASE_SCHEMA } from './baseConverters';
import { parseEntities, parseEntity } from './commonConverters';

// TODO @Evert align with tire module
const SCHEMA = {
  ...BASE_SCHEMA,
  content: 'comment',
};

export function parseComment(data: any): Comment | null {
  return parseEntity(data, SCHEMA, Comment);
}

export function parseComments(data: any): Array<Comment> {
  return parseEntities(data, SCHEMA, Comment);
}
